import { render, staticRenderFns } from "./ProdItem.vue?vue&type=template&id=02a8170a&"
import script from "./ProdItem.vue?vue&type=script&lang=js&"
export * from "./ProdItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports